import { getAuthClient, AuthClientInstance } from "@trumpf/ux.utils";
import { state, subscribe } from "../stores/notification-handler-store";
import { getUserSettings } from "../stores/user-settings-handler-store";
import { STAGE } from "@trumpf/notifies.notification-handler";

let unsubscribeCallback: () => void | null = null;
let _loadMore: () => void;
let subscribers = [];

const _log = (debug: boolean, msg: string) => {
    if (debug && console && typeof console.log === "function") {
        const now = new Date();
        const timestamp = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}.${now.getMilliseconds()}`;
        console.log(`[Notification Center] ${timestamp}: ${msg}`);
    }
};

export async function AuthSubscribe(
    version: string,
    env: string,
    locale: string,
    debug: boolean
) {
    if (unsubscribeCallback === null) {
        const startTime = Date.now(); // Record the start time
        _log(debug, `Token retrieve starting`);

        const authClientNotifications: AuthClientInstance = getAuthClient(
            "notificationmanagement"
        );

        // Setting up a subscription for new tokens
        unsubscribeCallback = authClientNotifications.subscribe(
            (newToken: string | null) => {
                if (newToken) {
                    state.set("token", newToken);
                    // Calculate the time taken
                    const endTime = Date.now();
                    const timeTaken = endTime - startTime;
                    _log(
                        debug,
                        `Received new token from remote in ${timeTaken}ms`
                    );
                    // Set up notification subscriptions upon receiving the new token
                    getUserSettings(
                        newToken,
                        locale,
                        version,
                        STAGE[env],
                        () => {
                            _loadMore = subscribe(
                                newToken,
                                locale,
                                version,
                                STAGE[env]
                            );
                        }
                    );
                }
            }
        );

        // Check if there is an existing token right away
        const initialToken = authClientNotifications.getAccessToken();
        if (initialToken) {
            state.set("token", initialToken);
            _log(
                debug,
                `Subscribing to auth events for environment ${env} (${STAGE[env]})`
            );
            getUserSettings(initialToken, locale, version, STAGE[env], () => {
                _loadMore = subscribe(
                    initialToken,
                    locale,
                    version,
                    STAGE[env]
                );
            });
            _log(debug, `Token found in local state.`);
        } else {
            _log(debug, "No initial token found, waiting for new token.");
        }
    }
}

export const loadMore = () => _loadMore();

export function AuthUnsubscribe(id: number) {
    subscribers = subscribers.filter((sub) => sub === id);
    if (subscribers.length > 0) return;
    if (unsubscribeCallback === null) return;

    unsubscribeCallback();
    state.set("notifications", []);
    state.set("counter", 0);
    unsubscribeCallback = null;
}
